import React, { useState, useRef, useEffect } from 'react';

import './ChannelList.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { useMobile } from '../../helpers/hooks';

const { LeftArrow, RightArrow, Subscribe } = icons;

export default function ChannelList(props) {
  const {
    user,
    channels = [],
    nextLink,
    getChannels,
    withoutTitle,
    showLoginPopup,
    subscribeChannel,
    fetchMoreChannels,
    unsubscribeChannel,
    eventTrackingCodes
  } = props;

  const list = useRef(null);
  const [isMobile, setIsMobile] = useMobile();
  const [currentPage, togglePage] = useState(1);

  const lastPage = Math.ceil(channels.length / 6);

  const channelList = isMobile ? channels.slice(0, 10) : channels;

  useEffect(() => {
    if (getChannels) getChannels({ variables: { channelLimit: 15 } });
  }, []);

  return (
    <section className="channelList">
      {!withoutTitle && <h4>Populaire Kanalen</h4>}

      <ul ref={list}>
        {channelList.map((channel, idx) => {
          const subscribedChannel =
            user.username &&
            user.channelSubscriptions.find(
              (item) => item.channel.id === channel.id
            );

          return (
            <li
              key={idx}
              className="channelList_item"
              onClick={() =>
                eventTrackingCodes && sendEvent(...eventTrackingCodes)
              }
            >
              {link(
                <img alt="channel-image" src={channel.imageUrl} />,
                `/channels/${channel.uri}`,
                nextLink
              )}

              {link(
                <p>{channel.displayName}</p>,
                `/channels/${channel.uri}`,
                nextLink
              )}

              <span>{channel.numberOfFollowers} volgers</span>

              {subscribedChannel ? (
                <button
                  className="channel_unsubscribe_button"
                  onClick={() => unsubscribe(channel)}
                >
                  <Subscribe />
                  Geabonneerd
                </button>
              ) : (
                <button onClick={() => subscribe(channel)}>
                  <Subscribe />
                  Abonneer
                </button>
              )}
            </li>
          );
        })}

        <li
          className="channelList_item channelList_last_item"
          key={channelList.length}
        >
          <p>Vind wat bij jou past!</p>

          {link(<p>Naar kanalen overzicht</p>, '/channels', nextLink)}
        </li>
      </ul>

      <div>
        {currentPage !== 1 && (
          <div
            className="channelList_arrow channelList_arrow_left"
            onClick={() => move('backward')}
          >
            <LeftArrow />
          </div>
        )}

        {currentPage !== lastPage && (
          <div
            className="channelList_arrow channelList_arrow_right"
            onClick={() => move('forward')}
          >
            <RightArrow />
          </div>
        )}
      </div>
    </section>
  );

  function move(direction) {
    const isForward = direction === 'forward';

    if (isForward && fetchMoreChannels)
      fetchMoreChannels({
        variables: {
          channelLimit: 12,
          channelOffset: channelList.length
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return;

          return { channels: [...prev.channels, ...fetchMoreResult.channels] };
        }
      });

    const translateX = `${isForward ? `-${currentPage}` : `-${currentPage - 2}`}00%`;

    list.current.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${translateX});
      transition-property: transform;
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }

  function subscribe(channel) {
    if (!user.username) return showLoginPopup('Log in om een kanaal te volgen');

    subscribeChannel({
      variables: {
        channelUri: channel.uri
      }
    });
  }

  function unsubscribe(channel) {
    unsubscribeChannel({
      variables: {
        channelUri: channel.uri
      }
    });
  }
}
